export default __webpack_public_path__ + "static/7-fd65aa6e2d230a57af2a8cfc5b6e66f1.jpg";